import { io } from 'socket.io-client';

class SocketManager {
  static #socketInstance = null;
  static get getSocketInstance() {
    if (!SocketManager.#socketInstance) {
      SocketManager.initSocket();
    }
    return SocketManager.#socketInstance;
  }

  static initSocket() {
    console.log('socket:::::');
    const token =
      window.localStorage?.getItem('accessToken') ||
      window.localStorage.getItem('accessToken') ||
      window.localStorage.getItem('commonaccessToken');
    console.log('token:::::', token);
    const includeNameSpace =
      process?.env?.REACT_APP_common_service_url.includes('/ma') ||
      process?.env?.REACT_APP_common_service_url.includes('/tsa');
    const baseURL = includeNameSpace
      ? process?.env?.REACT_APP_common_service_url
      : `${process?.env?.REACT_APP_common_service_url}/ma`;
    console.log('baseURL:::::', baseURL);

    const path = process?.env?.REACT_APP_websocket_path || '/commentSocket';
    // if (SocketManager.#socketInstance && refreshInstance) {
    //   SocketManager.#socketInstance.close();
    // }
    console.log('path:::::', path);
    SocketManager.#socketInstance = io(`${baseURL}`, {
      auth: { token },
      path,
      transports: ['websocket', 'polling'],
      timeout: 5000,
    });
  }
}

export default SocketManager;
